import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { map, reduce } from "lodash-es";
import { googleSilverTheme } from "../../../../theme/google";
import { BRAND_PURPLE_DARK, BRAND_BLUE, FOREST_GREEN_DARK, BRAND_BLUE_LIGHT } from "../../../../theme/colors";
import { formatPharmacy, getBrandknowledgeKey } from "../../../../utils";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import PersonIcon from "@material-ui/icons/Person";
import { Map, Marker } from "google-maps-react";

import HomeIcon from "@material-ui/icons/Home";
import { CircularProgress } from "@material-ui/core";

const StyledHomeIcon = styled(HomeIcon)`
  && {
    width: 1.3em;
    height: 1.4em;
  }
`;
const StyledGroupIcon = styled(PersonIcon)`
  && {
    width: 1.3em;
    height: 1.4em;
  }
`;

const MapInfoWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
const MapInfoContent = styled.div`
  margin: 1rem;
  text-align: center;
`;
const MapKpi = styled.div`
  border-bottom: 2px solid ${FOREST_GREEN_DARK};
  display: flex;
  justify-content: center;
  text-align: center;
`;

const KPINumber = styled.h2`
  margin-top: 2px;
  margin-bottom: 0.2rem;
  font-weight: normal;
`;
const customMarkerIcon = {
  path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
  fillColor: BRAND_BLUE, // Use your brand color
  fillOpacity: 1,
  strokeWeight: 1,
  strokeColor: BRAND_BLUE_LIGHT,
  scale: 1.5,
};
export const MeetingsMapColumn = ({
  google,
  meetingsFilter,
  loadingVisitor,
  filteredData,
  initialCenter,
  isVet
}) => {
  const { t } = useTranslation();
  return (
    <Col xl={3} md={3} style={{ display: "flex", flexDirection: "column" }}>
      <Row>
        <Col>
          <Card>
            <CardBody>
              <MapInfoWrapper>
                <MapInfoContent>
                  <MapKpi>
                    {loadingVisitor ? (
                      <KPINumber>
                        <CircularProgress size={34} style={{ color: BRAND_BLUE }} />
                      </KPINumber>
                    ) : (
                      <KPINumber>{filteredData.length}</KPINumber>
                    )}
                    <StyledHomeIcon style={{ fill: BRAND_PURPLE_DARK }} />
                  </MapKpi>
                  <h4
                    style={{
                      marginTop: "0.3rem",
                      fontWeight: "normal",
                    }}
                    className="header-title mb-4"
                  >
                    {t("dashboard.number_of_visits")}
                  </h4>
                </MapInfoContent>
                <MapInfoContent>
                  <MapKpi>
                    {loadingVisitor ? (
                      <KPINumber>
                        <CircularProgress size={34} style={{ color: BRAND_BLUE }} />
                      </KPINumber>
                    ) : (
                      <KPINumber>
                        {reduce(
                          filteredData,
                          (a, b) => {
                            return a + b.numberOfParticipants;
                          },
                          0
                        )}
                      </KPINumber>
                    )}
                    <StyledGroupIcon style={{ fill: BRAND_PURPLE_DARK }} />
                  </MapKpi>
                  <h4
                    className="header-title mb-4"
                    style={{ marginTop: "0.3rem", fontWeight: "normal" }}
                  >
                    {t("dashboard.number_of_staff")}
                  </h4>
                </MapInfoContent>
              </MapInfoWrapper>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card>
            <CardBody>
              <div
                id="gmaps-markers"
                className="gmaps"
                style={{ position: "relative" }}
              >
                <Map
                  mapTypeControl={false}
                  streetViewControl={false}
                  mapTypeControlOptions={false}
                  mapTypeIds={["roadmap"]}
                  google={google}
                  styles={googleSilverTheme}
                  initialCenter={initialCenter}
                  center={initialCenter}
                  zoom={meetingsFilter.city.length > 1 ? 4 : 10}
                  style={{ width: "100%", height: "100%" }}
                >
                  {filteredData
                    .map((item) => {
                      if (item.pharmacyLocation) {
                        const { lat, lon } = item.pharmacyLocation;
                        return { lat: lat, lng: lon };
                      }
                      return { lat: null, lng: null };
                    })
                    .map((postition, index) => (
                      <Marker
                        key={`${index}_marker`} position={postition}
                        // icon={{
                        //   url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'
                        // }}
                      />
                    ))}
                </Map>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row style={{ flex: 1, marginBottom: 24 }}>
        <Col>
          <Card style={{ height: "100%" }}>
            <CardBody>
              <h4 className="mt-0 header-title mb-4">
                {t("dashboard.meeting_log")}
              </h4>
              <ol className="activity-feed">
                {map(
                  filteredData.sort((a, b) =>
                    a.meetingDate < b.meetingDate ? 1 : -1
                  ),
                  (data, index) => (
                    <li key={`meeting_item_${index}`} className="feed-item">
                      <div className="feed-item-list">
                        <span className="date">
                          {new Date(data.meetingDate).toLocaleDateString(
                            "se-SE"
                          )}
                        </span>
                        <span className="info" style={{ fontWeight: "bold" }}>
                          {`${formatPharmacy(data.pharmacyName)}`}
                        </span>

                        <span className="info">
                          {meetingsFilter?.isRxProduct
                            ? t(
                              `brand_knowledge.${getBrandknowledgeKey(
                                data.brandKnowledgeRX,
                                isVet
                              )}`
                            )
                            : t(`brand_knowledge.${data.brandKnowledge}`)}
                        </span>
                        <span className="activity-text">
                          {data.meetingNotes}
                        </span>
                      </div>
                    </li>
                  )
                )}
              </ol>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Col>
  );
};
